//./react-app/src/scenes/sold-leads/index.tsx
import Header from '../../components/Header';
import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import AdFormStatisticsTable from '../../components/adserver/AdFormStatistics';

const AdFormStatisticsPage: FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box m="20px">
      <Box justifyContent="space-between" alignItems="center" display="flex">
        <Header
          title="Ad Form Auswertung"
          subtitle="Auswertungen zu verschiedenen Ad Formen/Typen/Positionen"
        />
      </Box>
      <Box display="grid" gridTemplateColumns="1fr" gap="20px">
        <Box>
          <Box height="250px" mt="-20px">
            <AdFormStatisticsTable />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdFormStatisticsPage;
